import "./styles.css";
import React, { useState } from "react";

export default function App() {
  let emojiDB = {
    "🧇": "waffle",
    "🧀": "cheese wedge",
    "🥐": "croissant",
    "🥨": "pretzel",
    "🥓": "bacon",
    "🌰": "chestnut",
    "🥩": "cut of meat",
    "🌭": "Hot Dog",
    "🥙": "Stuffed Flatbread",
    "🍘": "Rice Cracker",
    "🍚": "Cooked Rice",
    "🍛": "Curry Rice",
    "🍜": "Steaming Bowl",
    "🍝": "Spaghetti",
    "🍠": "Roasted Sweet Potato",
    "🍢": "Oden",
    "🍣": "Sushi",
    "🍤": "Fried Shrimp",
    "🍥": "Fish Cake with Swirl",
    "🥮": "Moon Cake",
    "🍡": "Dango",
    "🍵": "Teacup Without Handle",
    "🍶": "Sake",
    "🍾": "Bottle with Popping Cork",
    "🍷": "Wine Glass",
    "🍸": "Cocktail Glass",
    "🍹": "Tropical Drink",
    "🍺": "Beer Mug",
    "🍻": "Clinking Beer Mugs"
  };

  let emojiDBArray = Object.keys(emojiDB);

  const [clickedEmo, setClickedEmo] = useState("");
  function handleEmojiClick(item) {
    setClickedEmo(emojiDB[item]);
  }

  function handleEmojiInput(event) {
    setClickedEmo(emojiDB[event.target.value]);
  }

  return (
    <div className="App">
      <h1
        style={{ backgroundColor: "orange", padding: "1rem", color: "white" }}
      >
        Emoji Interpreter
      </h1>
      <input
        style={{ padding: "0.5rem", width: "15rem" }}
        placeholder="Put an emoji to know its name..."
        onChange={handleEmojiInput}
        type="text"
      />
      <br />
      <p style={{ fontWeight: "bold", fontSize: "1rem", marginBottom: "2rem" }}>
        {clickedEmo}
      </p>
      <div style={{ maxWidth: "600px", margin: "auto" }}>
        {emojiDBArray.map((item) => (
          <li
            key={item}
            onClick={() => handleEmojiClick(item)}
            style={{
              fontSize: "2rem",
              padding: "1rem",
              cursor: "pointer",
              listStyle: "none",
              display: "inline"
            }}
          >
            {item}
          </li>
        ))}
      </div>
    </div>
  );
}
